export default {"src":"/_next/static/media/Dartmouth.703f1798.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};